import { render } from "./DeployVnfAppliance.vue?vue&type=template&id=d0638070&scoped=true"
import script from "./DeployVnfAppliance.vue?vue&type=script&lang=js"
export * from "./DeployVnfAppliance.vue?vue&type=script&lang=js"

import "./DeployVnfAppliance.vue?vue&type=style&index=0&id=d0638070&lang=less&scoped=true"
import "./DeployVnfAppliance.vue?vue&type=style&index=1&id=d0638070&lang=less"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0638070"]])

export default __exports__